import ChannelSearch from "../../../../src/mdx/api/endpoints/channel-search.mdx";
import * as React from 'react';
export default {
  ChannelSearch,
  React
};